export * from './lib/shared.module';

export { AppService } from './lib/app/app.service';
export { ApiService } from './lib/api/api.service';
